import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { OutdoorMapPlatform, OutdoorPlacemarkData } from '../OutdoorMap/OutdoorMap';

import './OutdoorBalloon.css';

export interface OutdoorBalloonProps {
    billboard: OutdoorPlacemarkData;
    onCaptionClick: (platform: OutdoorMapPlatform) => void;
}

export class OutdoorBalloon extends React.Component<OutdoorBalloonProps> {
    render() {
        const { billboard } = this.props;

        return (
            <div className={Bem.cls('outdoor-balloon')}>
                {billboard.platforms.map((platform: OutdoorMapPlatform, index: number) => {
                    return (
                        <div className={Bem.cls('outdoor-balloon', 'platform')} key={index}>
                            <div
                                className={Bem.cls('outdoor-balloon', 'caption')}
                                onClick={() => {
                                    this.onCaptionClick(platform);
                                }}
                            >
                                {platform.format + ' ' + platform.resolution}
                            </div>
                            <div className={Bem.cls('outdoor-balloon', 'provider')}>{platform.provider}</div>
                        </div>
                    );
                })}
            </div>
        );
    }

    private onCaptionClick = (platform: OutdoorMapPlatform) => {
        this.props.onCaptionClick(platform);
    };
}
